import { createAction } from 'redux-actions-helpers'
import { ParentItemType } from './types'

export const fetchParents = createAction(
  '@@profile-parents/FETCH_PARENTS',
  (id: string): any => ({ id })
)

export const fetchParentsSuccess = createAction(
  '@@profile-parents/FETCH_PARENTS_SUCCESS',
  (result: ParentItemType[]): any => ({ result })
)

export const fetchParentsFailure = createAction(
  '@@profile-parents/FETCH_PARENTS_FAILURE',
  (error: string): any => ({ error })
)

export const createParent = createAction(
  '@@profile-parents/CREATE_PARENT',
  (
    gender: 'male' | 'female',
    first_name?: string,
    middle_name?: string,
    last_name?: string,
    birthdate?: string,
    contact_email?: string,
    contact_phone?: string
  ): any => ({
    gender,
    first_name,
    middle_name,
    last_name,
    birthdate,
    contact_email,
    contact_phone,
  })
)

export const createParentSuccess = createAction(
  '@@profile-parents/CREATE_PARENT_SUCCESS'
)

export const createParentFailure = createAction(
  '@@profile-parents/CREATE_PARENT_FAILURE',
  (error: string): any => ({ error })
)

export const editParent = createAction(
  '@@profile-parents/EDIT_PARENT',
  (
    parent_id: string,
    gender: 'male' | 'female',
    first_name?: string,
    middle_name?: string,
    last_name?: string,
    birthdate?: string,
    contact_email?: string,
    contact_phone?: string
  ): any => ({
    parent_id,
    gender,
    first_name,
    middle_name,
    last_name,
    birthdate,
    contact_email,
    contact_phone,
  })
)

export const editParentSuccess = createAction(
  '@@profile-parents/EDIT_PARENT_SUCCESS'
)

export const editParentFailure = createAction(
  '@@profile-parents/EDIT_PARENT_FAILURE',
  (error: string): any => ({ error })
)

export const uploadPhoto = createAction(
  '@@profile-parents/UPLOAD_PHOTO',
  (parent_id: string, photo: File): any => ({ parent_id, photo })
)

export const uploadPhotoSuccess = createAction(
  '@@profile-parents/UPLOAD_PHOTO_SUCCESS'
)

export const uploadPhotoFailure = createAction(
  '@@profile-parents/UPLOAD_PHOTO_FAILURE',
  (error: string): any => ({ error })
)

export const removePhoto = createAction(
  '@@profile-parents/REMOVE_PHOTO',
  (parent_id: string): any => ({ parent_id })
)

export const removePhotoSuccess = createAction(
  '@@profile-parents/REMOVE_PHOTO_SUCCESS'
)

export const removePhotoFailure = createAction(
  '@@profile-parents/REMOVE_PHOTO_FAILURE',
  (error: string): any => ({ error })
)

export const destroy = createAction('@@profile-parents/DESTROY')
